<template>
  <div>
    <Head :title="`${form.crtr_name}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/creator">Creator</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.crtr_name}}
    </h1>
    <trashed-message v-if="creator.deleted_at" class="mb-6" @restore="restore"> This creator has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.crtr_name" :error="form.errors.crtr_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
          <select-input v-model="form.crtr_is_influencer" :error="form.errors.crtr_is_influencer" class="pb-8 pr-6 w-full lg:w-1/2" label="Influencer">
            <option value="0">Employee</option>
            <option value="1">Influencer</option>
            <option value="2">Anchor</option>
          </select-input>
        <text-input  v-if="form.crtr_is_influencer == 0"  v-model="form.pkm_empl_id" :error="form.errors.pkm_empl_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Employee ID" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <!-- <button v-if="!creator.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Creator</button> -->
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Creator</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    creator: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        crtr_id: this.creator.crtr_id,
        crtr_name: this.creator.crtr_name,
        pkm_empl_id: this.creator.pkm_empl_id,
        crtr_is_influencer: this.creator.crtr_is_influencer,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/creator/${this.creator.crtr_id}`)
    },
    // destroy() {
    //   if (confirm('Are you sure you want to delete this contact?')) {
    //     this.$inertia.delete(`/creator/${this.creator.crtr_id}`)
    //   }
    // },
    restore() {
      if (confirm('Are you sure you want to restore this contact?')) {
        this.$inertia.put(`/creator/${this.creator.crtr_id}/restore`)
      }
    },
  },
}
</script>
